export const EMAIL_MAX_LENGTH = 255;
export const EMAIL_REGEXP =
  // eslint-disable-next-line no-useless-escape
  /^([^@\s\."'\(\)\[\]\{\}\\/,:;\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]+\.)*[^@\s\."'\(\)\[\]\{\}\\/,:;\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]+@[^@\s\."'\(\)\[\]\{\}\\/,:;\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]+(\.[^@\s\."'\(\)\[\]\{\}\\/,:;\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]+)*$/m;

export const validationEmailRules = {
  required: {
    value: true,
    message: 'errors.fieldRequired'
  },
  pattern: {
    value: EMAIL_REGEXP,
    message: 'errors.enterValidEmail'
  },
  maxLength: {
    value: EMAIL_MAX_LENGTH,
    message: 'validation.valueLongerThan255'
  }
};
